import styled from 'styled-components';

export const Wrapper = styled.div<{ $peeking?: boolean }>`
  width: 100%;
  max-width: 100%;
  padding-block: 0;
  padding-inline: ${({ $peeking }) => ($peeking ? '0' : '1rem')};
  background-color: var(--t-brand-bg-color);
  color: var(--t-brand-fg-color);

  @media (min-width: 768px) {
    padding-inline: ${({ $peeking }) => ($peeking ? '0' : '1.5rem')};
  }

  @media (min-width: 992px) {
    padding-inline: ${({ $peeking }) => ($peeking ? '0' : '2rem')};
  }
`;

export const HeaderWrapper = styled.div`
  margin-block-end: 1.5rem;

  @media (min-width: 768px) {
    margin-block-end: 2rem;
  }

  @media (min-width: 992px) {
    margin-block-end: 2.5rem;
  }
`;

export const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
`;

export const SwiperWrapper = styled.div<{ $peeking?: boolean }>`
  width: 100%;
  overflow: ${({ $peeking }) => ($peeking ? 'visible' : 'hidden')};

  .swiper {
    width: 100%;
    height: auto;
    overflow: ${({ $peeking }) => ($peeking ? 'visible' : 'hidden')};
    padding-block: 0.5rem;
  }

  .swiper-slide {
    height: auto;
    display: flex;
    align-items: stretch;
    width: ${({ $peeking }) => ($peeking ? '85%' : 'auto')};

    @media (min-width: 768px) {
      width: ${({ $peeking }) => ($peeking ? '45%' : 'auto')};
    }

    @media (min-width: 992px) {
      width: ${({ $peeking }) => ($peeking ? '30%' : 'auto')};
    }
  }

  .swiper-wrapper {
    align-items: stretch;
  }
`;

export const SlideContent = styled.div<{ $peeking?: boolean }>`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: var(--t-cards-border-radius, 14px);
  overflow: hidden;
`;

export const ControlsWrapper = styled.div<{ $imageOverlay?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-block-start: ${({ $imageOverlay }) => ($imageOverlay ? '0' : '1.5rem')};
  padding-inline: ${({ $imageOverlay }) => ($imageOverlay ? '0' : '1rem')};
  position: ${({ $imageOverlay }) => ($imageOverlay ? 'absolute' : 'relative')};
  inset-block-end: ${({ $imageOverlay }) => ($imageOverlay ? '1rem' : 'auto')};
  inset-inline-start: ${({ $imageOverlay }) => ($imageOverlay ? '50%' : 'auto')};
  transform: ${({ $imageOverlay }) => ($imageOverlay ? 'translateX(-50%)' : 'none')};
  z-index: ${({ $imageOverlay }) => ($imageOverlay ? '10' : 'auto')};

  @media (min-width: 768px) {
    margin-block-start: ${({ $imageOverlay }) => ($imageOverlay ? '0' : '2rem')};
    padding-inline: ${({ $imageOverlay }) => ($imageOverlay ? '0' : '1.5rem')};
    inset-block-end: ${({ $imageOverlay }) => ($imageOverlay ? '1.5rem' : 'auto')};
  }

  @media (min-width: 992px) {
    margin-block-start: ${({ $imageOverlay }) => ($imageOverlay ? '0' : '2.5rem')};
    padding-inline: ${({ $imageOverlay }) => ($imageOverlay ? '0' : '2rem')};
    inset-block-end: ${({ $imageOverlay }) => ($imageOverlay ? '2rem' : 'auto')};
  }
`;
